import CustomModal from 'components/Common/CustomModal'
import React, { useState } from 'react'
import { inputStyle } from 'views/Orders/CreateOrder'

import { toast } from 'react-toastify';
import api from 'api';

const CreateBrand = ({ handleModal, getUsers, loading, setLoading }) => {
    let [user, setData] = useState({
        name: "",
        email: ''
    })

    const handleChange = (e) => {
        setData((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const handleSubmit = (e) => {
        setLoading(true)
        e.preventDefault();
        if (user.name === '') {
            setLoading(false)
            return toast.error("Please enter user's name");
        }

        let formData = new FormData();

        for (let key in user) {
            if (key === 'preferences') {
                formData.append(key, JSON.stringify(user[key]));
            } else {
                formData.append(key, user[key]);
            }
        }
        api('post', '/users/brand', formData)
            .then((res) => {
                setLoading(false)
                toast.success(
                    user.email
                        ? 'Brand created — invitation email sent'
                        : 'Brand created. Use the activate button in the list to turn it on.'
                );
                getUsers();
                handleModal();
            })
            .catch(() => {
                setLoading(false)
            });
    };
    return (
        <CustomModal heading='Create Brand' buttonName='Create' handleModal={handleModal} handleSave={handleSubmit} loading={loading}>
            <label style={{
                marginTop: '10px',
                fontWeight: 600,
                fontSize: '16px',
                fontFamily: "Outfit",
                color: '#1C1C1C'
            }} htmlFor="">Brand Name</label><br />

            <input onChange={handleChange} name='name' value={user.name} placeholder='Enter here' style={inputStyle} type="text" />
            <label style={{
                marginTop: '10px',
                fontWeight: 600,
                fontSize: '16px',
                fontFamily: "Outfit",
                color: '#1C1C1C'
            }} htmlFor="">Email <span style={{ fontWeight: 400, fontSize: '13px', color: '#888' }}>(optional — enables portal access)</span></label><br />

            <input onChange={handleChange} name='email' value={user.email} placeholder='Enter here' style={inputStyle} type="text" />
        </CustomModal>
    )
}

export default CreateBrand